import '@fontsource/inter'
import React, {PropsWithChildren, useEffect, useMemo} from 'react'
import {ThemeProvider, CssBaseline, GlobalStyles} from '@mui/material'
import {useAppSelector} from 'src/hooks'
import {buildThemeNew} from './theme'
import {APP_BACKGROUND} from './tokens'
import {loadPspTheme, savePspTheme} from './persistedTheme'
import {ToastProvider} from 'src/components-new/feedback/ToastProvider'

type ThemeProviderNewProps = PropsWithChildren<{
  themeOverride?: Record<string, any>
}>

const ThemeProviderNew: React.FC<ThemeProviderNewProps> = ({children, themeOverride}) => {
  const pspTheme = useAppSelector(state => state.pspConfigReducer.data.theme)

  // Al refresh lo store è vuoto; usiamo l'ultimo tema PSP salvato in localStorage come
  // fallback così lo spinner di bootstrap non mostra il colore di default.
  const effective = themeOverride ?? (pspTheme.primaryColor ? pspTheme : loadPspTheme())

  // Aggiorna il tema persistito ogni volta che la config PSP viene caricata.
  useEffect(() => {
    if (pspTheme.primaryColor) {
      savePspTheme(pspTheme)
    }
  }, [pspTheme.primaryColor]) // eslint-disable-line react-hooks/exhaustive-deps

  const theme = useMemo(
    () => buildThemeNew(effective),
    [effective.primaryColor, effective.hoverbutton, effective.secondaryColor, effective.darkerColor] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles styles={{body: {backgroundColor: APP_BACKGROUND}}} />
      <ToastProvider>
        {children}
      </ToastProvider>
    </ThemeProvider>
  )
}

export default ThemeProviderNew
